import {
  Crosshair,
  Puzzle,
  Workflow,
  Layers,
  Sparkles,
  Shield,
  ExternalLink,
  Bot,
  Plug,
  Rocket,
  Gauge,
  Webhook,
  Radio,
} from 'lucide-react';

const ICON_MAP = {
  Crosshair,
  Puzzle,
  Workflow,
  Layers,
  Sparkles,
  Shield,
  ExternalLink,
  Bot,
  Plug,
  Rocket,
  Gauge,
  Webhook,
  Radio,
};

export function resolvePluginIcon(name, fallback = Puzzle) {
  if (!name) return fallback;
  return ICON_MAP[name] || fallback;
}
